import { Card, CardBody, Col } from "reactstrap";
import { Alerts, H5, P } from "../../../../AbstractElements";
import { AdditionalAlertTitle } from "../../../../Constants/Constants";
import { AdditionalAlertData, AdditionalAlertSubTitle } from "../../../../Data/UiKits/Alert";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const AdditionalAlert = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={AdditionalAlertTitle} span={AdditionalAlertSubTitle} />
        <CardBody className="dark-alert">
          {AdditionalAlertData &&
            AdditionalAlertData.map((item, index) => (
              <Alerts color={`light-${item.class}`} key={index}>
                <H5 className={`alert-heading pb-2 txt-${item.class}`}>{item.head}</H5>
                <P>{item.text}</P>
                <hr />
                <P className="mb-0">{item.subtext}</P>
              </Alerts>
            ))}
        </CardBody>
      </Card>
    </Col>
  );
};
export default AdditionalAlert;
